import gql from 'graphql-tag';

export default gql`
  mutation blockRequestedIntegration($integrationId: ID!) {
    integration: blockRequestedIntegration(integrationId: $integrationId) {
      id
      status
      type
    }
  }
`;
